import Joi from 'joi';
import { COMMENT_MIN_LENGTH } from '../constants/DateChangeReviewConstants';
import { CHANGE_DATE_REQUEST_STATUS } from '../../calendar/constants/ChangeDateRequestConstants';

const COMMENT_ERROR_MESSAGE = 'Comment field is required. Must be a minimum of 25 characters.';

const DateChangeReviewValidator = {
  schema: Joi.object({
    Status: Joi.valid(
      CHANGE_DATE_REQUEST_STATUS.APPROVED,
      CHANGE_DATE_REQUEST_STATUS.DECLINED
    ).required(),
    DeclineComment: Joi.string().when('Status', {
      is: CHANGE_DATE_REQUEST_STATUS.DECLINED,
      then: Joi.string().min(COMMENT_MIN_LENGTH).required().messages({
        'string.empty': COMMENT_ERROR_MESSAGE,
        'string.min': COMMENT_ERROR_MESSAGE
      }),
      otherwise: Joi.string().allow('').optional()
    })
  })
};

export default DateChangeReviewValidator;
